import Vue from 'vue';
import { AxiosPromise } from 'axios';
import {
  Response,
  TireStoringContractSeasonInfo,
} from '@/models';

class TireStoringContractSeasonInfoService extends Vue {
  private ROOT_API = process.env.VUE_APP_ROOT_API + '/webapi/tire-season-info';

  public getByIds(ids: any[]): AxiosPromise<Response<TireStoringContractSeasonInfo[]>> {
    return Vue.axios.get<Response<TireStoringContractSeasonInfo[]>>(this.ROOT_API + '/' + ids.join());
  }

}
export const tireStoringContractSeasonInfoService = new TireStoringContractSeasonInfoService();
